import * as dto from 'client/dto';

import { DropdownGroup } from 'components/_controls/BdModal/BdDropdownMenuModal';

// #region =========== CONNECTIVITY (Applies to both) ===========

export const DefaultConnectivityGroupBy = dto.ConnectivityGroupByType.Airport;
export type ConnectivityProvinceGroupByDisclaimerStatus = 'hidden' | 'shown' | 'user-hidden';

export type ConnectivityToggleRequestType = 'people' | 'disease';

export type ConnectivityLocationFormat = {
  highlightText: string;
  appendText?: string;
  grayedText?: string;
};

export type ConnectivityGroupByRequest = {
  originGroupBy: dto.ConnectivityGroupByType;
  destinationGroupBy: dto.ConnectivityGroupByType;
};

export type ConnectivityODLocationRequest = {
  originId?: number;
  destinationId?: number;
};

export const ConnectivityGroupByOptions = [
  { text: 'Airport', value: dto.ConnectivityGroupByType.Airport },
  { text: 'County', value: dto.ConnectivityGroupByType.County },
  { text: 'State/Province', value: dto.ConnectivityGroupByType.Province },
  { text: 'Country', value: dto.ConnectivityGroupByType.Country },
];

// #endregion

// #region =========== Movement of People ===========
export const MopODPageSize = 20;

export const DefaultMopSort = dto.TravelVolumeSortType.TotalVolumeHighToLow;

export type MopBulkUpdateRequest = {
  originGroupBy: dto.ConnectivityGroupByType;
  destinationGroupBy: dto.ConnectivityGroupByType;
  isDomesticIncluded: boolean;
  isGroundIncluded: boolean;
  sort: dto.TravelVolumeSortType;
};

export type MopOriginDestinationRow = {
  origin: string;
  destination: string;
  travelVolume: number;
};

export type MopSortOption = {
  shortText?: string;
  longText?: string;
  sortType: dto.TravelVolumeSortType;
};

export const MopSortOptions: MopSortOption[] = [
  {
    longText: 'Total Travel: High to Low',
    sortType: dto.TravelVolumeSortType.TotalVolumeHighToLow,
  },
  { longText: 'Air Travel: High to Low', sortType: dto.TravelVolumeSortType.AirVolumeHighToLow },
  {
    longText: 'Ground Travel: High to Low',
    sortType: dto.TravelVolumeSortType.GroundVolumeHighToLow,
  },
];

// #endregion

// #region  =========== Movement of Disease ===========
export const ModODPageSize = 10;

export const DefaultDiseaseRisksShown = 5;
export const DefaultShownAggRisks = 10;
export const DefaultModSort = dto.DiseaseMovementSortType.AffectedTravellerNumbersHighToLow;

export type ModBulkUpdateRequest = {
  originGroupBy: dto.ConnectivityGroupByType;
  destinationGroupBy: dto.ConnectivityGroupByType;
  isDomesticChecked: boolean;
  filteredDiseaseIds: number[];
};

export type ModSortOption = {
  shortText: string;
  longText?: string;
  sortType: dto.DiseaseMovementSortType;
};

export const ModOriginSortOptions: ModSortOption[] = [
  {
    shortText: 'A - Z for Origin',
    longText: 'Alphabetical ascending (A to Z) by origin',
    sortType: dto.DiseaseMovementSortType.OriginLocationAToZ,
  },
  {
    shortText: 'Z - A for Origin',
    longText: 'Alphabetical descending (Z to A) by origin',
    sortType: dto.DiseaseMovementSortType.OriginLocationZToA,
  },
];

export const ModDestinationSortOptions: ModSortOption[] = [
  {
    shortText: 'A - Z for Destination',
    longText: 'Alphabetical ascending (A to Z) destination',
    sortType: dto.DiseaseMovementSortType.DestinationLocationAToZ,
  },
  {
    shortText: 'Z - A for Destination',
    longText: 'Alphabetical descending (Z to A) by destination',
    sortType: dto.DiseaseMovementSortType.DestinationLocationZToA,
  },
];

export const DiseaseRiskSortOptions: ModSortOption[] = [
  {
    shortText: 'Highest to Lowest',
    sortType: dto.DiseaseMovementSortType.AffectedTravellerNumbersHighToLow,
  },
  {
    shortText: 'Lowest to Highest',
    sortType: dto.DiseaseMovementSortType.AffectedTravellerNumbersLowToHigh,
  },
];

export const ModSortOptionsGrouped: DropdownGroup<dto.DiseaseMovementSortType>[] = [
  {
    groupTitle: 'Sort by number of infected travellers',
    selectedGroupTitle: 'Number of infected travellers',
    options: DiseaseRiskSortOptions.map(opt => ({
      text: opt.shortText,
      value: opt.sortType,
    })),
  },
  {
    groupTitle: 'Sort by origin',
    selectedGroupTitle: 'Origin',
    options: ModOriginSortOptions.map(opt => ({
      text: opt.longText,
      value: opt.sortType,
    })),
  },
  {
    groupTitle: 'Sort by destination',
    selectedGroupTitle: 'Destination',
    options: ModDestinationSortOptions.map(opt => ({
      text: opt.longText,
      value: opt.sortType,
    })),
  },
];

// #endregion
